// Mirrors PublisherWebsiteImportService.MAX_FILE_BYTES / maxRowsPerFile on the backend, which
// re-validates the file on launch; the client checks only save a useless upload.
export const IMPORT_MAX_FILE_SIZE_MB = 1;
// RES-7310: the row cap is the account's website limit (billing details `websiteLimit`). This is
// only the fallback while that is unknown (not loaded yet, or an older API returning 0).
export const IMPORT_DEFAULT_MAX_ROWS = 1000;

export const getImportMaxRows = (websiteLimit?: number): number =>
  websiteLimit && websiteLimit > 0 ? websiteLimit : IMPORT_DEFAULT_MAX_ROWS;
export const BYTES_IN_MB = 1024 * 1024;

export const CSV_EXTENSION = '.csv';
export const CSV_MIME_TYPE = 'text/csv';
export const IMPORT_TEMPLATE_FILE_NAME = 'publisher-websites-import-template';
export const IMPORT_REPORT_FILE_NAME = 'publisher-websites-import-report';

export const IMPORT_FILE_INPUT_ID = 'publisher-websites-import-file';

// grpc-web reports a fetch that failed before any response headers arrived (network drop,
// proxy reset, CORS-less error reply) as Code.Unknown with this exact text; Code.Unavailable
// is the server-side equivalent. Neither says anything useful to the user.
export const GRPC_CODE_UNKNOWN = 2;
export const GRPC_CODE_UNAVAILABLE = 14;
export const GRPC_WEB_NO_HEADERS_MESSAGE = 'Response closed without headers';
export const UPLOAD_INTERRUPTED_MESSAGE =
  'The upload was interrupted. Please check your connection and try again';
export const UPLOAD_RETRY_ATTEMPTS = 1;

export type ImportModalView = 'upload' | 'status';
